module.exports = __webpack_public_path__ + "img/divideService.35f61cdd.svg";